import '../../styles/DashboardComponents.css';

const equipementTypes = {
  'faucet': 'Robinet',
  'wc': 'Toilettes',
  'shower': 'Douche',
  'urinal': 'Urinoir',
  'machine': 'Autres équipements'
};

const letterRateColors = {
  A: '#00bf63',
  B: '#c7de26',
  C: '#f6cc27',
  D: '#fc7c2c',
  E: '#ff5a3d',
  F: '#ff1b3b',
  G: '#c0003f'
};

const RatePerEquipment = ({ data }) => {
  if (!data) return null;

  // Transformer l'objet en tableau
  const sortedData = Object.entries(data)
    .map(([key, values]) => ({
      key,
      type: equipementTypes[key] || key,
      number: values.number,
      letterRate: values.letter_rate,
      consumption: values.real_consumption
    }))
    // Trier par nombre décroissant, mais mettre "Autres équipements" en dernier
    .sort((a, b) => {
      if (a.type === 'Autres équipements') return 1;
      if (b.type === 'Autres équipements') return -1;
      return b.number - a.number;
    });

  return (
    <table className="equipment-table">
      <thead>
        <tr>
          <th>Type d'équipement</th>
          <th>Nombre</th>
          <th>Note</th>
          <th>Consommation (m³/an)</th>
        </tr>
      </thead>
      <tbody>
        {sortedData.map((item, index) => (
          <tr key={index}>
            <td>{item.type}</td>
            <td>{item.number}</td>
            <td>
              <span
                className="letter-rate-badge"
                style={{ backgroundColor: letterRateColors[item.letterRate] || '#ccc' }}
              >
                {item.letterRate}
              </span>
            </td>
            <td>{Math.round(item.consumption)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default RatePerEquipment;
